import { CategoryResponse } from '../../constants/types'
import { CATEGORIES_URL } from '../../constants/urls'
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

export const categoriesApi = createApi({
  reducerPath: 'categories/api',
  baseQuery: fetchBaseQuery({
    baseUrl: CATEGORIES_URL,
  }),
  tagTypes: ['Category'],
  endpoints: (build) => ({
    getCategories: build.query<CategoryResponse[], number | void>({
      query: () => ({
        url: '',
        credentials: 'include',
      }),
      providesTags: ['Category'],
    }),
  }),
})
